import { f7, f7ready } from "framework7-vue";
import i18n from "./i18n.js";
import { useKeycloakStore } from "./pinia-stores/keycloak.js";
import {
  getIntentUrl,
  clearIntentUrl,
} from "./composables/useSessionGuard.js";

const MOBILE_URL_SCHEME =
  import.meta.env.VITE_AVOCASH_MOBILE_URL_SCHEME || "avocash://login";

let expiryTriggered = false;

export function markSessionExpiry() {
  expiryTriggered = true;
}

export function consumeSessionExpiry() {
  const triggered = expiryTriggered;
  expiryTriggered = false;
  return triggered;
}

let expiredToast = null;
let resumeToast = null;

function getLocale() {
  return (navigator.language || "en").split("-")[0];
}

export function sessionExpiredToast() {
  if (expiredToast) return;
  f7ready(() => {
    if (!f7.toast) return;
    if (expiredToast) return;
    const t = i18n.global.t;

    const loginToContinue = () => {
      const keycloakStore = useKeycloakStore();
      const intentUrl = getIntentUrl();
      const options = keycloakStore.isNativePlatform
        ? {
            redirectUri: `${MOBILE_URL_SCHEME}${intentUrl}`,
            locale: getLocale(),
          }
        : { locale: getLocale() };
      keycloakStore.login(options);
    };

    const goHome = () => {
      clearIntentUrl();
      if (f7.views?.main?.router) {
        f7.views.main.router.navigate("/");
      }
    };

    const buttonClasses =
      "button button-small button-outline button-round button-raised";

    expiredToast = f7.toast.create({
      destroyOnClose: true,
      text: `<div style="display:flex;flex-direction:column;gap:8px;align-items:center;text-align:center;">
        <span>${t("session.expired")}</span>
        <span style="display:flex;gap:8px;flex-wrap:wrap;justify-content:center;">
          <a id="session-login-button" class="${buttonClasses} color-primary border-color-primary" style="border-radius:32px;border-width:medium;">${t("session.loginToContinue")}</a>
          <a id="session-home-button" class="${buttonClasses} color-red border-color-red" style="border-radius:32px;border-width:medium;">${t("session.goHome")}</a>
        </span>
      </div>`,
      horizontalPosition: "center",
      position: "bottom",
      closeButton: true,
      closeTimeout: 8000,
      on: {
        close: () => {
          expiredToast = null;
        },
      },
    });

    expiredToast.open();

    const loginButton = document.querySelector("#session-login-button");
    loginButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      expiredToast.close();
      loginToContinue();
    });

    const homeButton = document.querySelector("#session-home-button");
    homeButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      expiredToast.close();
      goHome();
    });
  });
}

export function sessionResumeToast() {
  if (resumeToast) return;
  f7ready(() => {
    if (!f7.toast) return;
    if (resumeToast) return;
    const t = i18n.global.t;

    const buttonClasses =
      "button button-small button-outline button-round button-raised";

    resumeToast = f7.toast.create({
      destroyOnClose: true,
      text: `<div style="display:flex;flex-direction:column;gap:8px;align-items:center;text-align:center;">
        <span>${t("session.continueSession")}</span>
        <span style="display:flex;gap:8px;flex-wrap:wrap;justify-content:center;">
          <a id="session-continue-button" class="${buttonClasses} color-primary border-color-primary" style="border-radius:32px;border-width:medium;">${t("session.continue")}</a>
          <a id="session-cancel-button" class="${buttonClasses} color-red border-color-red" style="border-radius:32px;border-width:medium;">${t("common.cancel")}</a>
        </span>
      </div>`,
      horizontalPosition: "center",
      position: "bottom",
      closeButton: true,
      closeTimeout: 8000,
      on: {
        close: () => {
          resumeToast = null;
        },
      },
    });

    resumeToast.open();

    const continueButton = document.querySelector("#session-continue-button");
    continueButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearIntentUrl();
      resumeToast.close();
    });

    const cancelButton = document.querySelector("#session-cancel-button");
    cancelButton?.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      clearIntentUrl();
      resumeToast.close();
      if (f7.views?.main?.router) {
        f7.views.main.router.navigate("/");
      }
    });
  });
}
